import { api } from "@awtoban/shared";
import { useQuery } from "@tanstack/react-query";
import { useDebouncedValue } from "../../lib/useDebouncedValue";

export interface CompanyHit {
  id: string;
  code: string;
  name: string;
  status: "active" | "suspended";
  balance_tenne: number;
}

/**
 * Looks up the prepaid account a plate is enrolled to (active enrollment only),
 * debounced. Returns null when the plate isn't enrolled — a normal cash truck.
 */
export function useCompanyLookup(plate: string): CompanyHit | null {
  const debounced = useDebouncedValue(plate.trim(), 250);
  const enabled = debounced.length >= 2;

  const q = useQuery({
    queryKey: ["company-lookup", debounced.toUpperCase()],
    enabled,
    staleTime: 15_000,
    queryFn: async () => {
      const { data } = await api.POST("/api/v1/operator/company-lookup", {
        body: { plate: debounced } as never,
      });
      return ((data as { company: CompanyHit | null } | undefined)?.company ??
        null) as CompanyHit | null;
    },
  });
  return q.data ?? null;
}
